import type { FilterItemAll, FilterRootItem } from '../../../types/Filter';

export const mapFilterFieldFilters = (rootFilter: FilterItemAll, cb: (filterItem: FilterItemAll) => FilterItemAll | null) => {
    const result = cb(rootFilter);
    if (!result) {
        return result;
    }
    if (result.type === 'and' || result.type === 'or') {
        let length = result.filters.length;
        for (let i = 0; i < length; i++) {
            const filter = result.filters[i];
            if (!filter) {
                throw new Error('Cant get filter');
            }
            const childResult = mapFilterFieldFilters(filter, cb);
            if (childResult) {
                result.filters[i] = childResult;
            } else {
                result.filters.splice(i, 1);
                i -= 1;
                length -= 1;
            }
        }
    }
    return result;
};

export const mapFilterRootItem = (rootFilter: FilterRootItem, cb: (filterItem: FilterItemAll) => FilterItemAll | null): FilterRootItem | null => {
    const result = mapFilterFieldFilters(rootFilter, cb);
    if (!result) {
        return null;
    }
    if (result.type !== 'and' && result.type !== 'or') {
        throw new Error('Modified root filter result');
    }
    return result;
};

export const iterateFieldFilters = (filters: FilterItemAll[], cb: (filterItem: FilterItemAll) => void) => {
    filters.forEach((filter) => {
        cb(filter);
        if (filter.type === 'and' || filter.type === 'or') {
            iterateFieldFilters(filter.filters, cb);
        }
    });
};
